
import axios from 'axios';

import ArticleInfoBaseTemplate from '../info/ArticleInfoBaseTemplate';
import ArticleInfoCover from '@root/modules/article/components/info/ArticleInfoCover.vue';
import ArticleAuthorList from '@root/modules/article/components/authors/ArticleAuthorList.vue';
import ArticleInfoSources from '@root/modules/article/components/info/ArticleInfoSources.vue';
import ArticleInfoTags from '@root/modules/article/components/info/ArticleInfoTags.vue';
import ArticleInfoGooglePrefered from '@root/modules/article/components/info/ArticleInfoGooglePrefered.vue';
import ArticleInfoSocial from '@root/modules/article/components/info/ArticleInfoSocial.vue';
import getStreamElement from '@root/modules/article/utils/getStreamElement';
import { GetArticleViews } from '@root/common/types/getArticleViews';
import { faEye } from '@delfi.lt/fa-kit/icons/modules/classic/light';

type GetArticleViewsEntry = GetArticleViews['data']['articles']['items'][0];

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoCover,
    ArticleAuthorList,
    ArticleInfoSources,
    ArticleInfoTags,
    ArticleInfoSocial,
    ArticleInfoGooglePrefered,
  },
  data() {
    return {
      faEye,
      views: 0,
    };
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    showViews() {
      return this.$channelConfig('settings').showViews ?? false;
    },
    streamElement() {
      return getStreamElement(this.article);
    },
  },
  methods: {
    async getViews() {
      let views: number = 0;

      const assetId = this.article.content.leadElement?.content[0]?.attrs?.id;
      const response = await axios.get(`/api/get-article-views?assetId=${assetId}`, { timeout: 1000 });
      const { items }: GetArticleViews['data']['articles'] = response.data;

      if (items.length) {
        items.forEach((item: GetArticleViewsEntry) => {
          views += item.statistics.views;
        });
      }

      return views;
    },
  },
  async mounted() {
    if (this.showViews) {
      this.views = await this.getViews();
    }
  },
});
